import * as React from 'react';
import { SVGProps } from './SVGProps';
import classnames from 'classnames';

/**
 * LIST SVG component
 *
 * @returns
 */
function ListSVG({ className }: SVGProps) {
	return (
		<svg
			viewBox="0 0 576 576"
			className={classnames('roc-icon roc-list', className)}
			focusable="false"
			aria-hidden="true"
		>
			<path d="M32 32.001h511.999c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32h-511.999c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32z"></path>
			<path d="M32 416h511.999c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32h-511.999c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32z"></path>
			<path d="M32 224h511.999c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32h-511.999c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32z"></path>
		</svg>
	);
}

export default ListSVG;
